export default __webpack_public_path__ + "static/footer-social-0d678370184e77ed2b1fe6dedbb2c012.jpg";